<template>
  <el-card class="orderBox">
    <!-- <el-button
      type="success"
      size="small"
      style="margin-bottom: 10px"
      plain
      @click="$router.push('/shopList')"
      >{{ $t("category.jixugouwu") }}</el-button
    > -->
    <el-page-header
      style="margin-bottom: 20px"
      @back="$router.push('/')"
      :title="$t('category.jixugouwu')"
    >
    </el-page-header>
    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column prop="createTime" label="日期"> </el-table-column>
      <el-table-column prop="name" label="姓名"> </el-table-column>
      <el-table-column prop="address" label="地址"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="lookDetail(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- <el-dialog>
      <el-card class="successBox">
          <el-result icon="success" :title="$t('reservation.dingdantijiaochenggong')">
          </el-result>
          <el-descriptions
            :title="$t('reservation.dingdanxinxi')"
            direction="vertical"
            :column="2"
            border
          >
            <el-descriptions-item :label="$t('reservation.dingdanbianhao')">{{
              buyNumer
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('reservation.riqi')">{{
              date
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('reservation.jine')">{{
              priceAll
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('reservation.goumaishuliang')">
              {{ sucBuyCount }}
            </el-descriptions-item>
          </el-descriptions>
          <div style="margin: 50px 0 0; text-align: center">
            <el-button type="success" plain @click="$router.push('/shopList')">{{
            $t("button.fanhui")
          }}</el-button>
        </div>
      </el-card>
    </el-dialog> -->
  </el-card>
</template>

<script>
import { orderList } from "@/api/user";

export default {
  components: {},
  props: {},
  data() {
    return {
      tableData: [],
    };
  },
  mounted() {
    this.getOrder();
  },
  methods: {
    getOrder() {
      orderList().then((res) => {
        // console.log(res);
        this.tableData = res.data;
      });
    },
  },
};
</script>
<style scoped>
.orderBox {
  width: 40vw;
  margin: 0 auto;
  margin-top: 100px;
}
@media screen and (max-width: 768px) {
  .orderBox {
    width: 100vw;
    margin: 0 auto;
    margin-top: 10px;
  }
}
@media all and (min-width: 768px) and (max-width: 1199px) {
  .orderBox {
    width: 95vw;
    margin: 0 auto;
    margin-top: 10px;
  }
}
</style>